<template>
  <v-skeleton-loader
    :height="height"
    :transition="transition"
    :type="type"
    :width="width"
    :class="styles"
  ></v-skeleton-loader>
</template>

<script>
export default {
  props: ['type', 'transition', 'height', 'width', 'styles'],
}
</script>
